import { useAppDispatch, useAppSelector } from "redux/hooks";

import ThemeContext from "components/app/Context";
import ButtonLink from "components/common/Link";
import Toggle from "components/common/Toggle";
import MultipleSelectCheckmarks from "components/common/dropdowns/MultiSelect";
import SearchAppBar from "components/common/searchBar";
import { useTranslate } from "hooks/useTranslate";
import { uniq } from "lodash";
import { useContext } from "react";
import { tokens } from "styles/Tokens";
import { includeAboveProperty, minSearchStrLength } from "utils/CommonConstants";
import { converter_ArrayString } from "utils/CommonFunctions";
import { setMemberFilters } from "../PlanAssignment.slice";
import "./index.scss";

export default function Filters(props: any) {
  const dispatch = useAppDispatch();
  const translate = useTranslate();

  const { isPreDefinedNav = false } = props;

  const { isMobileScreen } = useContext(ThemeContext);

  const filters = useAppSelector((state: any) => state.PlanAssignment.memberSelection.filters);
  const roles = useAppSelector((state) => state.app?.userRoles?.roles);
  const propertyList = useAppSelector((state) => state.aboveProperty.propertyList);

  const getInputDetails = (input: any) => {
    if (input.length > minSearchStrLength || !input) {
      dispatch(setMemberFilters({ searchText: input }));
    }
  };

  const onFilterChange = (value: any, name: any) => {
    dispatch(setMemberFilters({ [name]: value }));
  };

  return (
    <>
      <div className="member_selection-actions">
        <SearchAppBar
          value={filters["searchText"]}
          getInputDetails={getInputDetails}
          placeholder={"Search by member’s name"}
          className="searchBar"
          isPreDefinedNav={isPreDefinedNav}
        />

        <div className="member_selection-filters">
          {filters["role"].length || filters["property"].length ? (
            <ButtonLink
              text="Clear all"
              sx={{ color: tokens.Text.General.Color }}
              textVariant="body2"
              underline="none"
              onClick={() => {
                dispatch(setMemberFilters({ role: [], property: [] }));
              }}
            />
          ) : (
            <></>
          )}

          <MultipleSelectCheckmarks
            name="role"
            label="Role"
            minWidth={isMobileScreen ? "160px" : "75px"}
            options={converter_ArrayString(uniq(roles?.map((el: any) => el?.roleName)), "name")}
            initialValues={filters["role"]}
            onChange={(value: any) => onFilterChange(value, "role")}
          />

          {props.showPropertyFilter && (
            <MultipleSelectCheckmarks
              name="property"
              label="Property"
              minWidth={isMobileScreen ? "160px" : "150px"}
              options={converter_ArrayString(propertyList?.map((el: any) => el?.innCode).sort(), "name")}
              initialValues={filters["property"]}
              onChange={(value: any) => onFilterChange(value, "property")}
              showInncode={true}
            />
          )}
        </div>
      </div>

      <div className="member_selection-toggle">
        <Toggle
          onChange={(value: any) => onFilterChange(value, includeAboveProperty)}
          labelOn={translate("common.includeAboveProperty")}
          labelOff={translate("common.excludeAboveProperty")}
          isToggleEnabled={filters[includeAboveProperty]}
          isLabelLeftSide
          sx={{ marginLeft: "8px" }}
        />
      </div>
    </>
  );
}
